import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "flex items-center justify-between border-b border-(--border-border-base-soft) py-3.5 first:pt-0" };
const _hoisted_2 = { class: "flex items-center gap-2 min-w-0" };
const _hoisted_3 = { class: "flex flex-col gap-px min-w-0" };
const _hoisted_4 = { class: "text-base font-medium leading-6 text-(--text-text-heading) truncate" };
const _hoisted_5 = {
    key: 0,
    class: "text-sm font-normal leading-5 text-(--text-text-black-default)"
};
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Avatar, Badge } from "@eudonet/opal";
import { formatMonthYear } from "@/shared/utils/date-formatting";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactActiveRelationRow',
    props: {
        fn: {},
        org: {}
    },
    setup(__props) {
        const props = __props;
        const { t, locale } = useI18n();
        const sinceText = computed(() => props.fn.startDate
            ? t("contact.detail.relations.widget.since", {
                date: formatMonthYear(props.fn.startDate, locale.value),
            })
            : "");
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(Avatar), {
                        name: __props.org.name,
                        img: __props.org.logoUrl ?? undefined,
                        size: "md",
                        entity: "organisation",
                        logo: "",
                        presentational: ""
                    }, null, 8 /* PROPS */, ["name", "img"]),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.org.name), 1 /* TEXT */),
                        (sinceText.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(sinceText.value), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _createVNode(_unref(Badge), {
                    type: "with-dot",
                    theme: "green",
                    label: __props.fn.title,
                    "show-close-icon": false,
                    size: "sm",
                    class: "shrink-0 ml-4"
                }, null, 8 /* PROPS */, ["label"])
            ]));
        };
    }
});
